import actionsTypes from './types';

export const createUser = (values) => ({
  type: actionsTypes.POST_CREATE_USER_TRIGGER,
  payload: values,
});

export const createUserRequest = () => ({
  type: actionsTypes.POST_CREATE_USER_REQUEST,
});

export const createUserSuccess = (createdUser) => ({
  type: actionsTypes.POST_CREATE_USER_SUCCESS,
  payload: createdUser,
});

export const createUserFailure = (error) => ({
  type: actionsTypes.POST_CREATE_USER_FAILURE,
  error: true,
  payload: error,
});

export const loginUser = (values) => ({
  type: actionsTypes.POST_LOGIN_USER_TRIGGER,
  payload: values,
});

export const resetLoginState = () => ({
  type: actionsTypes.RESET_LOGIN_USER_STATE,
});

export const loginUserStart = (source) => ({
  type: actionsTypes.POST_LOGIN_USER_REQUEST,
  payload: { source },
});

export const loginUserSuccess = () => ({
  type: actionsTypes.POST_LOGIN_USER_SUCCESS,
});

export const loginUserFailure = (error) => ({
  type: actionsTypes.POST_LOGIN_USER_FAILURE,
  error: true,
  payload: error,
});

export const subscribeNewsletterRequest = () => ({
  type: actionsTypes.PUT_NEWSLETTER_SUBSCRIPTION_REQUEST,
});

export const subscribeNewsletterSuccess = () => ({
  type: actionsTypes.PUT_NEWSLETTER_SUBSCRIPTION_SUCCESS,
});

export const subscribeNewsletterFailure = (error) => ({
  type: actionsTypes.PUT_NEWSLETTER_SUBSCRIPTION_FAILURE,
  error: true,
  payload: error,
});

export const socialLogin = (type, values, redirectLink, csrfToken, isRegister) => ({
  type: actionsTypes.POST_SOCIAL_LOGIN_TRIGGER,
  payload: {
    type,
    ...values,
    redirectLink,
    csrfToken,
    isRegister,
  },
});
